// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import timEntity from './entities/tim.json';
import timMenu from '../pages/tim/menu.json';
import timFullForm from '../pages/tim/forms/full.json';
import timContextForm from '../pages/tim/forms/context.json';
import timMiniForm from '../pages/tim/forms/mini.json';
import timLookupForm from '../pages/tim/forms/lookup.json';
import timTableView from '../pages/tim/views/table.json';
import timStagesView from '../pages/tim/views/stages.json';
import timCardsView from '../pages/tim/views/cards.json';
import timInlineView from '../pages/tim/views/inline.json';
import timBacklogView from '../pages/tim/views/backlog.json';
import timSplitView from '../pages/tim/views/split.json';
import timCalendarView from '../pages/tim/views/calendar.json';
import timDashboardView from '../pages/tim/views/dashboard.json';

/** Тип запису «Запис часу» зі сторінками пакета: меню, форми та подання з pages/tim/. */
export const timDefinition: IRecordTypeDefinition = {
  ...timEntity,
  views: assembleViewSet({
      table: timTableView,
      stages: timStagesView,
      cards: timCardsView,
      inline: timInlineView,
      backlog: timBacklogView,
      split: timSplitView,
      calendar: timCalendarView,
      dashboard: timDashboardView,
  }),
  form: timFullForm,
  forms: { full: timFullForm, context: timContextForm, mini: timMiniForm, lookup: timLookupForm },
  menu: timMenu,
} as IRecordTypeDefinition;
